module.exports = __webpack_public_path__ + "static/media/grid-item-b11.1d8802ef.png";